var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{
  'print-mode': _vm.$root.$data.printMode,
  'force-mobile': _vm.forceMobile,
  'force-desktop': _vm.forceDesktop,
  'embedded': _vm.$root.$data.embedded
},attrs:{"id":"app"}},[_c('GdprPopup'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }